module.exports = __webpack_public_path__ + "static/media/musicIntro.51aaf476.mp4";